import { BaseCurrencyInput, Button, Drawer } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/forms.module.scss";

export const DayOfMonthConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [selectedDays, setSelectedDays] = useState(node.data?.days || []);
  const [inputDay, setInputDay] = useState("");

  useEffect(() => {
    onChange &&
      onChange({ ...node, data: { ...node.data, days: selectedDays } });
  }, [selectedDays]);

  const selectDaysMonth = (day) => {
    if (+day < 1 || +day > 31 || Number.isNaN(day)) {
      return false;
    }
    setSelectedDays((oldArray) => [...new Set([...oldArray, day])]);
    setInputDay("");
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title="Em dias específicos do mês"
    >
      <div className={styles.daysMonth}>
        <p className={styles.label}>Defina os dias do mês</p>

        <div className="d-flex align-center mt-30">
          <BaseCurrencyInput
            label="Dia do mês"
            className="w-100 mr-15"
            precision={0}
            prefix=""
            max={2}
            design="two"
            value={inputDay}
            onEnter={() => selectDaysMonth(inputDay)}
            onChange={(v) => setInputDay(v)}
          />
          <Button design="simple" onClick={() => selectDaysMonth(inputDay)}>
            Aplicar
          </Button>
        </div>

        <div className={styles.days}>
          {selectedDays.map((day, _i) => (
            <div className={styles.day}>
              <span>{day}</span>
              <i
                className="far fa-times"
                onClick={() => {
                  setSelectedDays(
                    selectedDays.filter((value) => value !== day)
                  );
                }}
              />
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <Button
            onClick={() =>
              onSave({ ...node, data: { ...node.data, days: selectedDays } })
            }
            className="w-100"
            design="primary"
          >
            Aplicar
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
